export default __webpack_public_path__ + "javascripts/components/Podcast/SubscriptionOption/rss-874a40b68a27f47cbb2ef1afce5ee7f4.svg";